import { useMediaQuery } from './useMediaQuery';

/**
 * Below the `lg` breakpoint (1024px): phones and tablets get the mobile CMS
 * (bottom tab bar, Displays/Buildings/Media only). Matches the `lg:` classes
 * the shell and pages already use.
 */
export const MOBILE_MEDIA_QUERY = '(max-width: 1023.98px)';

export function useIsMobile(): boolean {
	return useMediaQuery(MOBILE_MEDIA_QUERY);
}
